import axios from 'axios'
import { handleTokenRejected, isExpiredTokenError } from './authReject';
import { getAccessToken, retryRequestAfterRefresh } from './tokenRefresh';
import {
  createCachedResponse,
  get as getCachedResponse,
  getTtl,
  isCacheable,
  set as setCachedResponse
} from './apiCache';

const service = axios.create({
  baseURL:  process.env.VUE_APP_BASE_API,
  Timeout: 5000,
})

const rk = (len) => {
  let text = "";
  const chars = "abcdefghijklmnopqrstuvwxyz1234567890";
  for (let i = 0; i < len; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return text;
};

const get_current_usid = () => localStorage.getItem('ec_current_usid');
const get_override_cifid = () => localStorage.getItem('override_cifid');

const isNetworkError = (error) => {
  if (!error.response) {
    return true;
  }
  return error.code === 'ECONNABORTED';
};

async function handleTokenExpiry(originalConfig) {
  const retryResponse = await retryRequestAfterRefresh(service, originalConfig);
  if (retryResponse) {
    return retryResponse;
  }

  handleTokenRejected();
  return Promise.reject('error');
}

service.interceptors.request.use(
  config => {
    if (isCacheable(config)) {
      const cached = getCachedResponse(config);
      if (cached !== null) {
        config.adapter = (cfg) => Promise.resolve(createCachedResponse(cfg, cached));
        return config;
      }
    }

    if (config.url.split("?").length > 1) {
      config.url = config.url + "&rk=" + rk(20);
    } else {
      config.url = config.url + "?rk=" + rk(20);
    }

    if (getAccessToken() != null && getAccessToken() !== '') {
      config.headers['ECAPP-TWXHEADER'] = getAccessToken();
    }
    if (get_current_usid() != null && get_current_usid() !== "") {
      config.headers['ec-current-usid'] = get_current_usid();
    }
    if (get_override_cifid() != null && get_override_cifid() !== "") {
      config.headers['ec-override-cifid'] = get_override_cifid();
    }
    return config;
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    if (response.status === 502) {
      return handleTokenExpiry(response.config);
    }

    if (response.status === 200 && isCacheable(response.config)) {
      setCachedResponse(response.config, response.data, getTtl(response.config));
    }

    return response;
  },
  error => {
    if (error.response !== undefined && error.response.status === 502) {
      return handleTokenExpiry(error.config);
    }

    if (isExpiredTokenError(error)) {
      return handleTokenExpiry(error.config);
    }

    if (error.config && isCacheable(error.config) && isNetworkError(error)) {
      const stale = getCachedResponse(error.config, { allowStale: true });
      if (stale !== null) {
        return Promise.resolve(createCachedResponse(error.config, stale));
      }
    }

    return Promise.reject(error);
  }
)

export default service;
